export const getPlainTextWithBlank = (value) => {
  const newValue = value
    .replaceAll('<span', '(<span')
    .replaceAll('</span>', '</span>)')
  const plainText = new DOMParser().parseFromString(newValue, 'text/html')
    .documentElement.textContent
  return plainText
}
